import React, { useState } from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import MaskedInputDefault from '../../components/Form/MaskedInputDefault';

import styles from './styles';

const IdentityDocumentPix = () => {
    const [document, setDocument] = useState('');
    return (
        <>
            <HeaderDefault title={"CPF/CNPJ"} />

            <View style={styles.container}>
                <View style={styles.contentDocument}>
                    <MaskedInputDefault
                        mask={document.length <= 14 ? "999.999.999-99" : "99.999.999/9999-99"}
                        keyboardType="numeric"
                        value={document}
                        onValueChange={(value) => setDocument(value)}
                        placeholder={"CPF/CNPJ"}
                    />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor da transferência:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>XX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>GPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default IdentityDocumentPix;